import React from 'react';
import PropTypes from 'prop-types';

import Avatar from 'components/Avatar';
import UpgradeRecruiterAccount from 'scenes/Dialog/components/UpgradeRecruiterAccount';
import LinkCandidateProfile from 'components/LinkCandidateProfile';
import FeedPostContentFirmLink from 'scenes/FeedPost/components/FeedPostContent/components/FeedPostContentFirmLink';

import { Role } from 'helpers/user';
import { LinkBuilder } from 'helpers/link-builder';

const FeedPostContentConnectionProfile = props => {
  const {
    user,
    post: {
      CandidateIDCon,
      FirmNameCon,
      FirmActiveCon,
      currentSchoolNameCon,
      FullNameCon,
      FirmUrlAliasCon,
      ConCandidatePictureUrl,
      OfficeLocationNameCon,
      TitleNameCon,
      ViewProfileCon,
      ViewAsRecruiterCon,
    },
  } = props;

  const isLink = !(
    (ViewProfileCon === 'No' && ViewAsRecruiterCon === 'No') ||
    (Role.isRecruiter(user) &&
      !Role.isCandidate(user) &&
      ViewAsRecruiterCon === 'No') ||
    (!Role.isRecruiter(user) &&
      Role.isCandidate(user) &&
      ViewProfileCon === 'No')
  );

  let link =
    (!Role.isCandidate(user) && Role.isRecruiterDefault(user)) ||
    (!Role.isRecruiter(user) && !Role.isCandidate(user))
      ? '#'
      : LinkBuilder.getProfileLink(CandidateIDCon);

  return (
    <div className="feed-post-content__profile">
      <Avatar
        size={52}
        link={isLink ? link : null}
        controlFunc={e => {
          if (!Role.isCandidate(user) && Role.isRecruiterDefault(user)) {
            UpgradeRecruiterAccount();
            e.preventDefault();
          } else if (!Role.isRecruiter(user) && !Role.isCandidate(user, true)) {
            e.preventDefault();
          }
        }}
        name={FullNameCon}
        image={ConCandidatePictureUrl}
      />
      <div className="feed-post-content__profile-info">
        <LinkCandidateProfile
          cls="feed-post-content__profile-name"
          clsSpan="feed-post-content__hero"
          styleSpan={{ marginRight: '0.5em' }}
          user={user}
          id={CandidateIDCon}
          name={FullNameCon}
          viewProfile={ViewProfileCon === 'Yes'}
          viewAsRecruiter={ViewAsRecruiterCon === 'Yes'}
        />
        <div className="feed-post-content__profile-description">
          <span className="feed-post-content__profile-text">
            {TitleNameCon} at
          </span>
          <FeedPostContentFirmLink
            cls="feed-post-content__profile-firm"
            clsSpan="feed-post-content__profile-firm--span"
            isActive={FirmActiveCon === 'Yes'}
            alias={FirmUrlAliasCon}
            firm={FirmNameCon}
            school={currentSchoolNameCon}
          />
        </div>
        <span>{OfficeLocationNameCon}</span>
      </div>
    </div>
  );
};

FeedPostContentConnectionProfile.propTypes = {
  user: PropTypes.object.isRequired,
  post: PropTypes.object.isRequired,
};

export default FeedPostContentConnectionProfile;
